export default __webpack_public_path__ + "static/media/grocerylist.f74653e5.png";